import {
  PRELAUNCH_DETAIL_ERROR,
  PRELAUNCH_DETAIL_LOADING,
  PRELAUNCH_DOWNLOAD_ERROR,
  PRELAUNCH_DOWNLOAD_LOADING,
  PRELAUNCH_FEATURE_DISABLED,
  PRELAUNCH_FORBIDDEN,
  PRELAUNCH_HISTORY_ERROR,
  PRELAUNCH_HISTORY_LOADING,
  PRELAUNCH_REPORT_ERROR,
  PRELAUNCH_REPORT_LOADING,
  PRELAUNCH_RESET,
  PRELAUNCH_SET_ACTIVE_TAB,
  PRELAUNCH_SET_CAMPAIGN_ID,
  PRELAUNCH_SET_DETAIL,
  PRELAUNCH_SET_FILTER_OPTIONS,
  PRELAUNCH_SET_HISTORY,
  PRELAUNCH_SET_REPORT,
  PRELAUNCH_SET_STATUS,
  PRELAUNCH_STATUS_ERROR,
  PRELAUNCH_STATUS_LOADING,
  PRELAUNCH_TRIGGER_CONFLICT,
  PRELAUNCH_TRIGGER_ERROR,
  PRELAUNCH_TRIGGER_LOADING,
  PRELAUNCH_TRIGGER_SUCCESS,
} from './types';

// Active tab constants – mirror the dashboard sections
export const TAB_SCOPE = 'scope';
export const TAB_DATA_QUALITY = 'dataQuality';
export const TAB_RISK = 'risk';
export const TAB_HISTORY = 'history';

const INITIAL_STATE = {
  // Identifiers
  campaignId: null,
  activeTab: TAB_SCOPE,

  // Trigger / retrigger
  isTriggerLoading: false,
  triggerResult: null, // { success, reportId, runNumber, jobId, status, message }
  triggerError: null,
  triggerConflict: null, // ALREADY_RUNNING — { message, reportId }
  featureDisabled: false, // FEATURE_DISABLED
  forbidden: false, // FORBIDDEN / RBAC

  // Status polling
  isStatusLoading: false,
  statusData: null, // { reportId, campaignId, runNumber, status, progressPct, startedAt, completedAt, executionTimeMs, errorMessage }
  statusError: null,

  // Full report metrics
  isReportLoading: false,
  reportData: null, // complete PreLaunchReport fields mapped to camelCase
  reportError: null,

  // Run history list
  isHistoryLoading: false,
  historyData: [], // array of summary objects
  historyError: null,

  // Drill-down detail
  isDetailLoading: false,
  detailData: null,
  detailError: null,

  // Filter options
  filterOptions: null,

  // Download
  isDownloadLoading: false,
  downloadError: null,
};

// eslint-disable-next-line default-param-last
const preLaunchReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    // ── UI state ──────────────────────────────────────────────────────────────
    case PRELAUNCH_SET_CAMPAIGN_ID:
      return { ...state, campaignId: action.payload };

    case PRELAUNCH_SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };

    case PRELAUNCH_RESET:
      return { ...INITIAL_STATE };

    // ── Trigger ───────────────────────────────────────────────────────────────
    case PRELAUNCH_TRIGGER_LOADING:
      return {
        ...state,
        isTriggerLoading: action.payload,
        triggerError: null,
        triggerConflict: null,
      };

    case PRELAUNCH_TRIGGER_SUCCESS:
      return {
        ...state,
        isTriggerLoading: false,
        triggerResult: action.payload,
        triggerConflict: null,
      };

    case PRELAUNCH_TRIGGER_ERROR:
      return {
        ...state,
        isTriggerLoading: false,
        triggerError: action.payload,
      };

    case PRELAUNCH_TRIGGER_CONFLICT:
      return {
        ...state,
        isTriggerLoading: false,
        triggerConflict: action.payload, // { message, reportId }
      };

    case PRELAUNCH_FEATURE_DISABLED:
      return { ...state, isTriggerLoading: false, featureDisabled: true };

    case PRELAUNCH_FORBIDDEN:
      return { ...state, isTriggerLoading: false, forbidden: true };

    // ── Status polling ────────────────────────────────────────────────────────
    case PRELAUNCH_STATUS_LOADING:
      return { ...state, isStatusLoading: action.payload };

    case PRELAUNCH_SET_STATUS:
      return {
        ...state,
        isStatusLoading: false,
        statusData: action.payload,
        statusError: null,
      };

    case PRELAUNCH_STATUS_ERROR:
      return { ...state, isStatusLoading: false, statusError: action.payload };

    // ── Full report ───────────────────────────────────────────────────────────
    case PRELAUNCH_REPORT_LOADING:
      return { ...state, isReportLoading: action.payload };

    case PRELAUNCH_SET_REPORT:
      return {
        ...state,
        isReportLoading: false,
        reportData: action.payload,
        reportError: null,
      };

    case PRELAUNCH_REPORT_ERROR:
      return { ...state, isReportLoading: false, reportError: action.payload };

    // ── History ───────────────────────────────────────────────────────────────
    case PRELAUNCH_HISTORY_LOADING:
      return { ...state, isHistoryLoading: action.payload };

    case PRELAUNCH_SET_HISTORY:
      return {
        ...state,
        isHistoryLoading: false,
        historyData: action.payload,
        historyError: null,
      };

    case PRELAUNCH_HISTORY_ERROR:
      return {
        ...state,
        isHistoryLoading: false,
        historyError: action.payload,
      };

    // ── Detail ────────────────────────────────────────────────────────────────
    case PRELAUNCH_DETAIL_LOADING:
      return { ...state, isDetailLoading: action.payload };

    case PRELAUNCH_SET_DETAIL:
      return {
        ...state,
        isDetailLoading: false,
        detailData: action.payload,
        detailError: null,
      };

    case PRELAUNCH_DETAIL_ERROR:
      return { ...state, isDetailLoading: false, detailError: action.payload };

    // ── Filter options ────────────────────────────────────────────────────────
    case PRELAUNCH_SET_FILTER_OPTIONS:
      return { ...state, filterOptions: action.payload };

    // ── Download ──────────────────────────────────────────────────────────────
    case PRELAUNCH_DOWNLOAD_LOADING:
      return {
        ...state,
        isDownloadLoading: action.payload,
        downloadError: null,
      };

    case PRELAUNCH_DOWNLOAD_ERROR:
      return {
        ...state,
        isDownloadLoading: false,
        downloadError: action.payload,
      };

    default:
      return state;
  }
};

export default preLaunchReducer;
